export default __webpack_public_path__ + "static/media/karma.ab81121c.svg";